import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const GDPR = () => {
  return (
    <div className="py-16 bg-white">
      <Helmet>
        <title>GDPR | Uvildig Økonomisk Rådgivning | Finansoptimering</title>
        <meta name="description" content="Generel information Ifølge Lov om behandling af personoplysninger (Persondataloven), Direktiv 95/46/EC (Databeskyttelsesdirektivet) og Forordning 2016/679 (EU-Databeskyttelsesforordningen), har du ret" />
      </Helmet>

      <div className="container mx-auto px-4 max-w-4xl">
        <nav className="text-sm text-slate-500 mb-8 flex items-center space-x-2">
          <Link to="/" className="hover:text-blue-600">Forsiden</Link>
          <span>/</span>
          <span className="text-slate-900 font-medium">GDPR</span>
        </nav>

        <h1 className="text-4xl font-extrabold text-slate-900 mb-10">GDPR</h1>

        <div className="prose prose-slate prose-lg max-w-none">
          <p className="font-bold">Generel information</p>
          <p>
            Ifølge Lov om behandling af personoplysninger (Persondataloven), Direktiv 95/46/EC (Databeskyttelsesdirektivet) og Forordning 2016/679 (EU-Databeskyttelsesforordningen), har du ret til at blive informeret om, hvilke personoplysninger vi, Finansoptimering ApS, CVR: DK-34085900, indsamler og behandler.
          </p>
          <p>
            Personoplysninger er enhver form for information om en identificeret eller identificerbar fysisk person. Det vil sige, at det er alle former for oplysninger, der direkte eller indirekte kan knytte sig til en person. Det kan f.eks. være navn, adresse, telefonnummer eller IP-adresser.
          </p>
          <p>
            Når vi indsamler personoplysninger om dig, sikrer vi altid, at dette sker på en klar og tydelig måde, så du er bekendt med, hvilke former for oplysninger, der indsamles og hvorfor oplysningerne indsamles.
          </p>
          <p>
            Oplysningerne behandles fortroligt og videregives kun til vores samarbejdspartnere og koncernforbundne selskaber, hvis det har et nødvendigt formål, eller offentlige myndigheder, hvor dette er lovbestemt.
          </p>
          <p>
            Med henblik på at sikre at dine persondata behandles i overensstemmelse med lovgivningen er Finansoptimering ApS defineret som den dataansvarlige, der indsamler dine data. Hvis du har spørgsmål angående disse vilkår eller tilsvarende, er du altid velkommen til at kontakte os:
          </p>
          <div className="bg-slate-50 p-6 rounded-2xl border border-slate-200 my-8 not-prose">
            <p className="font-bold text-slate-900">Finansoptimering ApS</p>
            <p className="text-slate-700">DK-34085900</p>
            <p className="text-slate-700">Lobovej 11</p>
            <p className="text-slate-700">9230 Svenstrup J</p>
            <p className="text-slate-700">Jesper@finansoptimering.dk</p>
          </div>

          <p className="font-bold">samtykke:</p>
          <p>
            Al rådgivning hos Finansoptimering starter med, at der indgås en skriftlig aftale, hvor du skriver under på, at vi må behandle dine data i rådgivningsmæssig sammenhæng. Vi benytter udelukkende dine data to at give dig den bedst mulige økonomiske rådgivning. Vi videregiver aldrig dine data til tredjemand uden forudgående skriftlig accept, ligesom vi aldrig benytter dine data til markedsføring.
          </p>
          <p>
            Du har til enhver tid mulighed for at trække dit samtykke tilbage ved at rette henvendelse til os pr. post til adressen Finansoptimering ApS, DK34085900, Lobovej 11, 9230 Svenstrup J eller pr. mail: jesper@finansoptimering.dk
          </p>
          <p>
            Såfremt du vælger at tilbagetage dit samtykke, skal du være opmærksom på, at det muligvis kan medføre indskrænkninger i de services vi kan tilbyde, f.eks. fremsendelse af nyhedsbreve.
          </p>
          <p>
            Du skal endvidere være opmærksom på, at vi i nogle tilfælde vil være berettiget til at fortsætte behandlingen af dine oplysninger, selvom du trækker dit samtykke tilbage, og den behandling, som baseres på samtykket, udløber. Hovedsageligt behandler vi dine oplysninger for at opfylde en aftale, som du er en part i, og for at overholde gældende lovgivning, herunder bogføringsloven.
          </p>

          <p className="font-bold">Indsigt plus information om, hvordan data behandles:</p>
          <p>Vi behandler data af såvel økonomisk som personlig karakter, og der behandles udelukkende data fremsendt af dig selv på baggrund af nedenstående liste:</p>
          
          <p className="font-bold">Generelt:</p>
          <ul>
            <li>Seneste årsopgørelse fra skat</li>
            <li>Nyeste budgetoversigt</li>
            <li>Nyeste forskudsopgørelse</li>
            <li>Seneste lønseddel/meddelelse om udbetaling af pensioner/øvrige udbetalingsmeddelelser</li>
            <li>Årsopgørelser fra banker – alle sider</li>
            <li>Den fulde rapport fra www.pensionsinfo.dk</li>
            <li>Aktuel udskrift med indestående på konti og depoter</li>
            <li>Årsopgørelser fra alle långivere m.v.– alle sider</li>
            <li>Seneste kvittering på alle lån (evt. PBS)</li>
            <li>Seneste ejendomsvurdering hus og evt. sommerhus</li>
            <li>Meddelelse om offentlige skatter og afgifter på hus og evt. sommerhus</li>
            <li>Navn og fødselsdato på evt. børn.</li>
            <li>Øvrige relevante oplysninger af betydning for din økonomi.</li>
          </ul>

          <p className="font-bold">Såfremt Du/I har virksomhed:</p>
          <ul>
            <li>Regnskab med noter og specifikationer for virksomhed de sidste 3 år</li>
            <li>Seneste råbalance</li>
            <li>Seneste udskrift fra Erhvervs- & Selskabsstyrelsen</li>
            <li>Opgørelse over værdipapirdepoter</li>
            <li>Øvrige relevante papirer.</li>
          </ul>

          <p className="font-bold">Såfremt du/I ønsker at købe fast ejendom:</p>
          <p>Salgsopstilling vedr. specifik eller repræsentativ ejendom.</p>

          <p className="font-bold">Hvornår indsamler vi personoplysninger</p>
          <p>
            Vi registrerer og gemmer de oplysninger, du giver til os, når du indgår en aftale med os, hvad enten dette sker fysisk, online, via post eller telefon. Vi registrerer hermed dine oplysninger i forbindelse med det ene formål at levere en vare eller ydelse og for at overholde gældende lovgivning.
          </p>
          <p>Vi indsamler derfor personoplysninger på følgende måde:</p>
          <ul>
            <li>Når du køber rådgivning af os (både fysisk, online, via post eller telefon),</li>
            <li>Når du tilmelder dig vores nyhedsbrev,</li>
            <li>Når du interagerer med os, f.eks. når du fremsender e-mails.</li>
          </ul>

          <p className="font-bold">Opbevaring af persondata</p>
          <p>
            Når du køber rådgivning hos os, vil vi som udgangspunkt opbevare dine personoplysninger i 5 år + løbende år i henhold til reglerne i bogføringsloven. Oplysningerne kan dog i nogle tilfælde opbevares længere, hvis det er nødvendigt for at overholde juridiske forpligtelser eller for at håndhæve vores aftaler.
          </p>

          <p className="font-bold">Retten til at blive glemt og begrænse behandling:</p>
          <p>
            Du har til hver en tid ret til at få dine oplysninger slettet. Finansoptimering har dog rådgiveransvar og er derfor lovgivningsmæssigt forpligtet til at opbevare dine oplysninger i 5 år. Al behandling af dine data kan dog stoppe, når du ønsker det.
          </p>

          <p className="font-bold">Klage</p>
          <p>
            Du har mulighed for at klage over vores behandling af dine oplysninger. Klage skal indgives til:
          </p>
          <p>
            Datatilsynet<br />
            Borgergade 28, 5<br />
            1300 København K<br />
            <a href="http://www.datatilsynet.dk/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">www.datatilsynet.dk</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default GDPR;
